import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Btn } from '../../components'

export default function OneInstructions(): React.ReactElement {
	const navigate = useNavigate()
	function submit(): void {
		navigate('/instrucoes')
	}
	useEffect(() => {
		const header = document.querySelector('.menu')
		if (header) {
			header.classList.remove('header--margin-left', 'header--centralize')
		}
	})
	return (
		<div className="bk h-full">
			<div className="container">
				<Helmet>
					<title> Avaliação </title>
					<meta name="description" content="Avaliação" />
				</Helmet>
				<h1>
					Desenvolvemos nossa avaliação da Brandtech para dar aos negócios e <br />
					as marcas uma maneira rápida e fácil de medir seu desempenho de
					<br />
					marketing e priorizar áreas para investir.
				</h1>

				<div className="timer">
					<img src="/assets/img/outhers/timer.png" alt="Tempo" title="Tempo" />
					<p> Leva 9 min </p>
				</div>

				<div className="center">
					<Btn placeholder="Iniciar avaliação" id="btn-iniciar-avaliacao" width="11.438rem" height="2.938rem" onClick={() => submit()} />
				</div>

				<p className="results">Seus resultados determinarão sua pontuação de maturidade na escala da metodologia Brandtech.</p>
			</div>
		</div>
	)
}
